/**
 * PDP product tabs and read-more toggles.
 */
(() => {
  const TAB_SELECTOR = '[data-pdp-tab]';
  const PANEL_SELECTOR = '[data-pdp-tab-panel]';
  const HOLDER_SELECTOR = '[data-pdp-truncated-holder]';
  const BUTTON_SELECTOR = '[data-pdp-truncated-button]';

  /**
   * @param {HTMLElement} holder
   */
  const initTabs = (holder) => {
    const tabs = holder.querySelectorAll(TAB_SELECTOR);
    const panels = holder.querySelectorAll(PANEL_SELECTOR);

    if (!tabs.length || !panels.length) return;

    /**
     * @param {string} tabId
     */
    const activateTab = (tabId) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.pdpTab === tabId;
        tab.classList.toggle('pdp-product-tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.pdpTabPanel === tabId;
        panel.hidden = !isActive;
        panel.classList.toggle('pdp-product-tabs__panel--active', isActive);
      });
    };

    const firstTab = tabs[0];
    if (firstTab) {
      activateTab(firstTab.dataset.pdpTab || '0');
    }

    holder.addEventListener('click', (event) => {
      const tab = /** @type {HTMLElement | null} */ (event.target.closest(TAB_SELECTOR));
      if (!tab || !holder.contains(tab)) return;

      event.preventDefault();
      activateTab(tab.dataset.pdpTab || '0');
    });
  };

  /**
   * @param {HTMLElement} holder
   */
  const initReadMore = (holder) => {
    const button = holder.querySelector(BUTTON_SELECTOR);
    const content = holder.querySelector('[data-pdp-truncated-content]');

    if (!button || !content) return;

    button.addEventListener('click', () => {
      const isExpanded = holder.hasAttribute('data-pdp-truncated-expanded');
      holder.toggleAttribute('data-pdp-truncated-expanded', !isExpanded);
      content.classList.toggle('pdp-product-tabs__entry--expanded', !isExpanded);
      button.textContent = isExpanded
        ? button.dataset.readMoreLabel || 'Read more...'
        : button.dataset.readLessLabel || 'Read less';
    });
  };

  const init = () => {
    document.querySelectorAll('[data-pdp-tabs]').forEach(initTabs);
    document.querySelectorAll(HOLDER_SELECTOR).forEach(initReadMore);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
